import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { usePackCustomerForm } from './hooks/usePackCustomerForm';

const { TextArea } = Input;

const Field = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div><label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>{children}</div>
);

const P151Form: React.FC = () => {
  const f = usePackCustomerForm();
  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!f.current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除「${f.current.fp510_01} ${f.current.fp510_10}」？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: f.doDelete,
    });
  };

  const modeLabel = f.mode === 'add' ? '新增' : f.mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={f.loading}>
      <div className="max-w-3xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          PACKING客戶資料建檔 (pwp151f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {f.records.length > 0 ? `${f.currentIdx + 1} / ${f.records.length}` : '無資料'}
          </span>
        </h2>

        <div className="flex items-center gap-2 mb-3">
          <Input placeholder="輸入代號或名稱查詢" value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && f.quickSearch(searchText.trim())}
            disabled={f.isEditing} style={{ width: 200 }} />
          <Button onClick={() => searchText.trim() && f.quickSearch(searchText.trim())} disabled={f.isEditing}>查詢</Button>
          <span className="mx-2" />
          <Button size="small" onClick={f.navFirst} disabled={f.isEditing || f.records.length === 0}>|&lt;</Button>
          <Button size="small" onClick={f.navPrev} disabled={f.isEditing || f.currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={f.navNext} disabled={f.isEditing || f.currentIdx >= f.records.length - 1}>&gt;</Button>
          <Button size="small" onClick={f.navLast} disabled={f.isEditing || f.records.length === 0}>&gt;|</Button>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex gap-4">
            <Field label="客戶代號 (FP510_01)">
              <Input value={f.code} onChange={e => f.setCode(e.target.value)} maxLength={12}
                disabled={f.mode !== 'add'} style={{ width: 160 }} />
            </Field>
            <Field label="客戶名稱 (FP510_10)">
              <Input value={f.name} onChange={e => f.setName(e.target.value)} maxLength={60}
                disabled={!f.isEditing} style={{ width: 280 }} />
            </Field>
          </div>

          <div className="flex gap-4">
            <Field label="收貨人 (FP510_11)">
              <Input value={f.recipient} onChange={e => f.setRecipient(e.target.value)} maxLength={10}
                disabled={!f.isEditing} style={{ width: 150 }} />
            </Field>
            <Field label="電話 (FP510_12)">
              <Input value={f.phone} onChange={e => f.setPhone(e.target.value)} maxLength={12}
                disabled={!f.isEditing} style={{ width: 180 }} />
            </Field>
          </div>

          <Field label="送貨地點 (FP510_13)">
            <TextArea value={f.address} onChange={e => f.setAddress(e.target.value)}
              disabled={!f.isEditing} rows={3} style={{ width: '100%' }} />
          </Field>
        </div>

        {f.current && f.mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-4">
            建立: {f.current.fp510_91} | 日期: {f.current.fp510_92 || '-'} | 修改: {f.current.fp510_93}
          </div>
        )}

        <div className="flex items-center gap-2">
          {!f.isEditing ? (
            <>
              <Button type="primary" onClick={f.startAdd}>新增</Button>
              <Button onClick={f.startEdit} disabled={!f.current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!f.current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={f.save}>儲存</Button>
              <Button onClick={f.cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P151Form;
